<div class="py-20">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
      <!-- Mission -->
      <div
        class="surface-elevated rounded-2xl p-8 border border-border group hover:border-primary/50 transition-all duration-300 relative overflow-hidden"
      >
        <div class="absolute inset-0 bg-gradient-to-br from-primary-soft/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
        <div class="flex items-center gap-4 mb-4 relative z-10">
          <div class="w-12 h-12 rounded-xl flex items-center justify-center bg-primary-soft/20 border border-primary/30 shadow-subtle group-hover:shadow-primary-glow transition-all duration-300">
            <i class="fa-solid fa-bullseye text-primary text-2xl"></i>
          </div>
          <h3 class="h3 text-text-primary">{{ 'about.mission.title' | translate }}</h3>
        </div>

        <p class="body-large text-text-secondary relative z-10">
          {{ 'about.mission.description' | translate }}
        </p>
      </div>

      <!-- Vision -->
      <div
        class="surface-elevated rounded-2xl p-8 border border-border group hover:border-primary/50 transition-all duration-300 relative overflow-hidden"
      >
        <div class="absolute inset-0 bg-gradient-to-br from-primary-soft/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
        <div class="flex items-center gap-4 mb-4 relative z-10">
          <div class="w-12 h-12 rounded-xl flex items-center justify-center bg-primary-soft/20 border border-primary/30 shadow-subtle group-hover:shadow-primary-glow transition-all duration-300">
            <i class="fa-solid fa-eye text-primary text-2xl"></i>
          </div>
          <h3 class="h3 text-text-primary">{{ 'about.vision.title' | translate }}</h3>
        </div>

        <p class="body-large text-text-secondary relative z-10">
          {{ 'about.vision.description' | translate }}
        </p>
      </div>
    </div>
  </div>
</div>
